<template>
  <div>
    <Accordion
      :is-open="false"
      class="pega-visible"
    >
      <template #head>
        絞り込み項目
      </template>
      <template #body>
        <div class="boss-layout boss-layout-vertical boss-layout-vertical-gap-large">
          <div>
            <div class="boss-table-3">
              <div class="boss-table-3-item">
                <div class="boss-table-3-head">
                  会員ID
                </div>
                <div class="boss-table-3-body">
                  <input
                    v-model.number="filterData.userId"
                    class="boss-input boss-input-fill"
                    data-test="input-user-id"
                    type="number"
                    :max="Number.MAX_SAFE_INTEGER"
                    min="0"
                    @keypress="onlyNumberInRange($event)"
                  >
                </div>
              </div>
              <div class="boss-table-3-item">
                <div class="boss-table-3-head">
                  氏名
                </div>
                <div class="boss-table-3-body">
                  <input
                    v-model="filterData.userName"
                    type="text"
                    class="boss-input boss-input-fill"
                    data-test="input-full-name"
                  >
                </div>
              </div>
              <div class="boss-table-3-item is-boss-only-pc">
                <div class="boss-table-3-head">
                  セミナーID
                </div>
                <div class="boss-table-3-body">
                  <select
                    v-model="filterData.conditionSeminarId"
                    class="boss-input-select"
                    data-test="select-seminar-ids"
                  >
                    <option value>
                      指定なし
                    </option>
                    <option
                      v-for="(id, i) in seminarIds"
                      :key="i"
                      :value="id"
                    >
                      {{ id }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="boss-table-3-item is-boss-only-pc">
                <div class="boss-table-3-head">
                  <input
                    id="duplicated-entry-check"
                    v-model="filterData.isDuplicatedEntries"
                    type="checkbox"
                    class="boss-input-checkbox"
                    false-value=""
                    data-test="check-duplicated"
                  >
                </div>
                <div class="boss-table-3-body">
                  <label
                    for="duplicated-entry-check"
                    class="pega-input"
                  >重複応募者のみ</label>
                </div>
              </div>
              <div class="boss-table-3-item">
                <div class="boss-table-3-head">
                  応募・メッセージ
                </div>
                <div class="boss-table-3-body">
                  <select
                    v-model="filterData.message"
                    class="boss-input-select"
                    data-test="select-message"
                  >
                    <option :value="{ isReplied: '',isRead: '' }">
                      指定なし
                    </option>
                    <option
                      v-for="option in messageResponseOptions"
                      :key="option.id"
                      :value="option.status"
                    >
                      {{ option.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="boss-table-3-item is-boss-only-pc">
                <div class="boss-table-3-head">
                  ステータス
                </div>
                <div class="boss-table-3-body">
                  <label
                    class="pega-entry-list-search-checkbox-label"
                    :data-test="'select-status-0'"
                  >
                    <input
                      v-model="filterData.statusIds"
                      :value="null"
                      type="checkbox"
                      class="boss-input-checkbox"
                    >
                    <span>−</span>
                  </label>
                  <label
                    v-for="(option, i) in seminarStatusesExcludedFinish"
                    :key="i"
                    class="pega-entry-list-search-checkbox-label"
                    :data-test="`select-status-${option.id}`"
                  >
                    <input
                      v-model="filterData.statusIds"
                      :value="option.id"
                      type="checkbox"
                      class="boss-input-checkbox"
                    >
                    <span>{{ option.name }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Accordion>
  </div>
</template>

<script>
import Accordion from '@/components/atoms/Accordion'
import _ from 'lodash'
import { mapGetters } from 'vuex'
import * as definition from '@/lib/labelValueMappings'
import eventValidations from '@/lib/eventValidations'

export default {
  components: {
    Accordion
  },
  mixins: [eventValidations],
  props: {
    entryObjects: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      filterData: {
        userId: '',
        userName: '',
        conditionSeminarId: '',
        statusIds: [],
        message: {
          isRead: '',
          isReplied: ''
        },
        isDuplicatedEntries: false
      },
      messageResponseOptions: definition.seminarEntryMessageResponseStatus
    }
  },
  computed: {
    seminarIds () {
      return this.pickEntryProperty('seminar.id')
    },
    ...mapGetters([
      'seminarStatuses'
    ]),
    finishStatusId: () => 5,
    seminarStatusesExcludedFinish () {
      return this.seminarStatuses.filter(stautus => stautus.id !== this.finishStatusId)
    }
  },
  watch: {
    filterData: {
      handler: 'update',
      deep: true
    },
    entryObjects: {
      handler: 'update'
    }
  },
  methods: {
    update () {
      // shouldFilter:絞り込み条件がするかどうか filterFunction: 絞り込みの処理
      const filters = [
        { shouldFilter: _.get(this.filterData, 'userId'), filterFunction: this.filterUserId },
        { shouldFilter: _.get(this.filterData, 'userName'), filterFunction: this.filterUserName },
        { shouldFilter: _.get(this.filterData, 'conditionSeminarId'), filterFunction: this.filterConditionSeminarId },
        { shouldFilter: (_.isBoolean(_.get(this.filterData, 'message.isRead')) || _.isBoolean(_.get(this.filterData, 'message.isReplied'))), filterFunction: this.filterMessage },
        { shouldFilter: _.get(this.filterData, 'statusIds').length, filterFunction: this.filterStatus },
        { shouldFilter: _.get(this.filterData, 'isDuplicatedEntries'), filterFunction: this.filterDuplicatedEntries }
      ]

      const hasFilter = !!filters.filter(filter => filter.shouldFilter).length

      const filterFunctions = _.overEvery(filters.filter(filter => filter.shouldFilter).map(filter => filter.filterFunction))
      this.entryObjects.forEach(entryObject => {
        entryObject.isShow = hasFilter ? filterFunctions(entryObject.entry) : true
        entryObject.isChecked = false
      })

      this.$emit('filteredUpdate', this.entryObjects)
    },
    filterUserId (entry) {
      return !!String(_.get(entry, 'userId')).match('^' + _.get(this.filterData, 'userId'))
    },
    filterUserName (entry) {
      return [`${_.get(entry, 'userLastName', '')}${_.get(entry, 'userFirstName', '')}`, `${_.get(entry, 'userLastNameKana', '')}${_.get(entry, 'userFirstNameKana', '')}`]
        .some(name => _.includes(name, this.hiraToKana(_.get(this.filterData, 'userName'))))
    },
    filterConditionSeminarId (entry) {
      return _.get(entry, 'seminar.id') === _.get(this.filterData, 'conditionSeminarId')
    },
    filterMessage (entry) {
      // 未読が選択された場合・メッセージ未読またはレジュメ未読を対象とする
      if (_.get(this.filterData, 'message.isRead') === false) {
        return _.isMatch(_.get(entry, 'message'), _.get(this.filterData, 'message')) || _.get(entry, 'isRead') === false
      } else {
        return _.isMatch(_.get(entry, 'message'), _.get(this.filterData, 'message'))
      }
    },
    filterStatus (entry) {
      return _.get(this.filterData, 'statusIds').some(statusId =>
        statusId === _.get(entry, 'statusId')
      )
    },
    filterDuplicatedEntries (entry) {
      return _.get(entry, 'isDuplicatedEntries')
    },
    hiraToKana (str) {
      return str.replace(/[\u3041-\u3096]/g, function (match) {
        const chr = match.charCodeAt(0) + 0x60
        return String.fromCharCode(chr)
      })
    },
    pickEntryProperty (path) {
      return _(this.entryObjects).map('entry').map(_.property(path)).uniqWith(_.isEqual).value()
    }
  }
}
</script>
